<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.382,0C13.7607,1.04064e-15,14.107,0.214002,14.2764,0.552786C14.2764,0.552786,16,4,16,4C16,4,16,15,16,15C16,15.5523,15.5523,16,15,16C15,16,1,16,1,16C0.447715,16,6.76354e-17,15.5523,0,15C0,15,0,4,0,4C0,4,1.72361,0.552786,1.72361,0.552786C1.893,0.214002,2.23926,2.91624e-16,2.61803,0C2.61803,0,13.382,0,13.382,0C13.382,0,13.382,0,13.382,0ZM8,6C7.72,6,7.47,6.11,7.29,6.29C7.29,6.29,7.29,6.29,7.29,6.29C7.29,6.29,5.29,8.29,5.29,8.29C5.29,8.29,5.20602,8.38565,5.20602,8.38565C5.07639,8.55417,5,8.76667,5,9C5,9.55,5.45,10,6,10C6.28,10,6.53,9.89,6.71,9.71C6.71,9.71,6.71,9.71,6.71,9.71C6.71,9.71,7,9.41,7,9.41C7,9.41,7,12,7,12C7,12,7.00676,12.1162,7.00676,12.1162C7.0648,12.612,7.48929,13,8,13C8.55,13,9,12.55,9,12C9,12,9,12,9,12C9,12,9,9.41,9,9.41C9,9.41,9.29,9.7,9.29,9.7C9.29,9.7,9.37131,9.77644,9.37131,9.77644C9.54204,9.91918,9.76,10,10,10C10.55,10,11,9.55,11,9C11,8.72,10.89,8.47,10.71,8.29C10.71,8.29,10.71,8.29,10.71,8.29C10.71,8.29,8.71,6.29,8.71,6.29C8.71,6.29,8.61435,6.20602,8.61435,6.20602C8.44583,6.07639,8.23333,6,8,6C8,6,8,6,8,6ZM13,2C13,2,3,2,3,2C3,2,2,4,2,4C2,4,14,4,14,4C14,4,13,2,13,2C13,2,13,2,13,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Unarchive',
} as DefineComponent
</script>
